export default __webpack_public_path__ + "static/media/Sensotrend_kayttoon-otto.04da47be.pdf";